import {mapGetters, mapMutations} from 'vuex'

import {
  GETTER_SCROLL_TO_EL,
  GETTER_SHOW_OVERLAY,
  GETTER_SHOW_PREVIEW,
  GETTER_SHOW_NAV,
  MUTATE_SET_SCROLL_TO_EL,
  MUTATE_TOGGLE_OVERLAY,
  MUTATE_TOGGLE_PREVIEW,
  MUTATE_TOGGLE_NAV
} from "../store/modules/shared";

export default {
  computed:{
    ...mapGetters({
      scrollToEl  : GETTER_SCROLL_TO_EL,
      showOverlay : GETTER_SHOW_OVERLAY,
      showPreview : GETTER_SHOW_PREVIEW,
      showNav     : GETTER_SHOW_NAV
    })
  },
  methods:{
    ...mapMutations({
      setScrollToEl : MUTATE_SET_SCROLL_TO_EL,
      toggleOverlay : MUTATE_TOGGLE_OVERLAY,
      togglePreview : MUTATE_TOGGLE_PREVIEW,
      toggleNav     : MUTATE_TOGGLE_NAV
    })
  }
}